import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { EditHistoryData, EditHistoryOptions } from './edit-history';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { AbsLanguage } from 'src/app/features/abstract/absLanguage';
import { LanguagesMapper } from 'src/app/model/languages/languages-mapper';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { AppState } from 'src/app/store/root.state';

@Component({
  selector: 'app-edit-history',
  templateUrl: './edit-history.component.html',
  styleUrls: ['./edit-history.component.scss']
})
export class EditHistoryComponent extends AbsLanguage implements OnInit, OnChanges {

  @Input('options') options: EditHistoryOptions | undefined;
  @Input('data') data!: EditHistoryData | undefined;

  parsedOptions: EditHistoryOptions;
  parsedData: EditHistoryData | undefined;

  languages!: LanguagesMapper;

  constructor(
    protected override store: Store<AppState>,
    protected override translateService: TranslateService,
    private translatePipe: TranslatePipe,
    private languageService: LanguagesService,
  ) {
      // translate super constructor
    super(store, translateService);
    this.languages = this.languageService.getTexts();
    this.parsedOptions = {
      hidden: false,
    };

  }

  ngOnInit(): void {

  }

  ngOnChanges(change: { options: SimpleChange, data: SimpleChange }): void {
    if(change.data) {
      this.parseData(change.data.currentValue);
    }
    if(change.options) {
      this.parseOptions(change.options.currentValue);
    }
  }

  parseOptions(op: EditHistoryOptions): void {
    this.parsedOptions = _.cloneDeep(op);
  }

  parseData(da: EditHistoryData): void {
    this.parsedData = _.cloneDeep(da);
  }

  getDate(): Date {
    return new Date();
  }

}
